export default "__VITE_ASSET__jlgaY13p__"